<template>
    <div class="w-full flex flex-col gap-y-[12px]">
        <customNav v-for="(value,idx) in linksData" :datas="value" :key="idx"/>
    </div>
</template>
<script>
import { links } from '@/utils/sidebar-data';
import customNav from './custom-nav.vue';
export default {
    name : "SideBarHeader1",
    components:{
        customNav
    },
    props:[],
    data(){
        return {
            linksData:links
        }
    },
    methods:{
        expand(){
            this.isExpanded = !this.isExpanded;
        }
    }
}
</script>